import { load as loadPasswordForm } from './Passwords/password-form-loader';
import { load as loadPaymentMethodsList } from './PaymentMethods/payment-method-list-loader';
import { load as loadSubscriptionsList } from './Subscriptions/subscription-list-loader';

export function load() {
  loadPasswordForm();
  loadSubscriptionsList();
  loadPaymentMethodsList();
}
